export class CurrentDialTargetChanged {
   public static readonly type = '[CurrentDialTarget] Current dial target changed';
   constructor(public dialTarget: string) {}
}
